import Image from 'next/legacy/image';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import { useEffect, useState } from 'react';
import Paragraph, { VARIANT } from '@/components/Paragraph';
import { NAVIGATION_FROM_IS_ASSISTED_ORDERING } from '@/constants/common';
import { useAppSelector } from '@/hooks/reduxHooks';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import locationIcon from '@/images/location/location.webp';
import CurrentLocation from '@/models/Location';
import { selectCurrentLocation } from '@/store/features/locationSlice';
import CustomEventTypes from '@/utils/analytics/customEventTypes';
import { getCookieValue } from '@/utils/helper';
// import { trackCustomEvent } from '@/utils/analytics/googleAnalytics'

export enum AddAddressFrom {
  'HYPERLOCAL',
  'SERVICE',
}
interface Props {
  selectAddressOption: boolean;
  handleSelectAddress: VoidFunction;
  from?: AddAddressFrom;
}
const AddAddress = ({
  selectAddressOption,
  handleSelectAddress,
  from = AddAddressFrom.HYPERLOCAL
}: Props) => {
  const {
    t
  } = useTranslation('cart');
  const currentLocation = useAppSelector(selectCurrentLocation);
  const {
    push
  } = useRouter();
  const [location, setLocation] = useState<CurrentLocation>();
  const {
    trackCustomEvent
  } = useTriggerEvents();
  const isFromService = from === AddAddressFrom.SERVICE;
  const orderingFor = getCookieValue(NAVIGATION_FROM_IS_ASSISTED_ORDERING) === 'true';
  const addAddressHandler = () => {
    trackCustomEvent(CustomEventTypes.ADD_ADDRESS);
    let url = '/address/new';
    if (isFromService) {
      url = '/address/new?pa=n';
    }
    push(url);
  };
  const onSelectAddress = () => {
    trackCustomEvent(CustomEventTypes.SELECT_ADDRESS);
    handleSelectAddress();
  };
  useEffect(() => {
    setLocation(currentLocation);
  }, [currentLocation]);
  return <>
      <div className="flex">
        <Image height={48} width={48} src={locationIcon} alt={'location_icon_alt'} title={'location_icon_title'} data-sentry-element="Image" data-sentry-source-file="AddAddress.tsx" />

        {location ? <span className="ml-2">
            <Paragraph variant={VARIANT.BIG} isHighlighted>
              {t('your_location')}
            </Paragraph>
            <Paragraph variant={VARIANT.MEDIUM} className="text-neutral-70">
              {`${location.area}, ${location.city}, ${location.postalCode}`}
            </Paragraph>
          </span> : null}
      </div>
      {selectAddressOption ? <div className="flex justify-between gap-2 mt-4">
          <button className={`${isFromService ? 'bg-primary-100 text-white' : 'bg-white text-primary-100'} border border-primary-100 border-solid rounded-lg w-full h-12 text-center`} onClick={addAddressHandler} data-testid="add-address-btn">
            {isFromService ? t('add_farmer_address') : t('add_address')}
          </button>
          {(!isFromService || orderingFor) && <button data-testid="select-address-footer-btn" className="bg-primary-100 rounded-lg w-full h-12 text-white text-center" onClick={onSelectAddress}>
              {t('select_address')}
            </button>}
        </div> : <button data-testid="add-address-to-proceed-btn" className="bg-primary-100 mt-4 rounded-lg w-full h-12 text-white text-center" onClick={addAddressHandler}>
          {t('add_address_to_proceed')}
        </button>}
    </>;
};
export default AddAddress;